import { useController } from '@aha-app/mvc';
import AhaEditorV2Controller from '../controllers/AhaEditorV2Controller';

// Determine if the editor or any of its toolbars have focus.
const useAhaEditorFocused = (): boolean => {
  const controller = useController(AhaEditorV2Controller);
  const { focused } = controller.state;

  return focused;
};

export default useAhaEditorFocused;
